/*
  Support & FAQ (sections/section-support-faq.liquid). Search filters the rows by question and
  answer text and hides a topic with no match; the topic index underlines the group in view.
  Without this script every question is still there and every <details> still opens.
*/
(function () {
  function setup(root) {
    if (root.dataset.sfaqReady) return;
    root.dataset.sfaqReady = '1';
    var input = root.querySelector('[data-sfaq-search]');
    var none = root.querySelector('[data-sfaq-none]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sfaq-group]'));
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-sfaq-topic]'));

    function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    groups.forEach(function (g) {
      Array.prototype.forEach.call(g.querySelectorAll('[data-sfaq-row]'), function (r) { r._text = norm(r.textContent); });
    });

    function filter() {
      var q = norm(input.value.trim()), any = false;
      groups.forEach(function (g) {
        var shown = 0;
        Array.prototype.forEach.call(g.querySelectorAll('[data-sfaq-row]'), function (r) {
          var hit = !q || r._text.indexOf(q) !== -1;
          r.hidden = !hit;
          if (hit) shown++;
        });
        g.hidden = shown === 0;
        if (shown) any = true;
      });
      none.hidden = any;
    }
    if (input) input.addEventListener('input', filter);

    function current(id) {
      links.forEach(function (a) {
        if (a.getAttribute('href') === '#' + id) {
          a.setAttribute('aria-current', 'true');
          if (a.scrollIntoView && window.matchMedia('(max-width: 1024px)').matches) {
            var list = a.closest('ul');
            if (list) list.scrollTo({ left: a.parentNode.offsetLeft - 40, behavior: 'smooth' });
          }
        } else a.removeAttribute('aria-current');
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) current(e.target.id); });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach(function (g) { io.observe(g); });
    }
    links.forEach(function (a) {
      a.addEventListener('click', function () { current(a.getAttribute('href').slice(1)); });
    });
  }
  function init() { document.querySelectorAll('[data-sfaq]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
